/* eslint-disable no-unneeded-ternary */

import AppBar from '@material-ui/core/AppBar'
import { withStyles } from '@material-ui/core/styles'

// We can inject some CSS into the DOM.

const styles = theme => ({
  appBar: {
    color: `var(--gameday-body-textColorAlt, ${theme.body.textColorAlt})`,
    // marginTop: theme.spacing(4),

    background: `var(--gameday-body-textColor, ${theme.body.textColor})`,
    display: 'inline-flex',
    // width: 'auto',
    boxShadow: 'none',
    // border: '1px solid #ccc',
    borderRadius: '5px',
  },
})

function PrimaryAppBar({ position, style, classes, children }) {
  return (
    <AppBar position={position} style={style} className={classes.appBar}>
      {children ? children : ''}
    </AppBar>
  )
}

export default withStyles(styles)(PrimaryAppBar)
